var map = {
	"./accordion.css": "c16b",
	"./authen.css": "adc3",
	"./bank-card.css": "2490",
	"./common_asset.css": "ba4c",
	"./footer.css": "46f5",
	"./gameiframe.css": "b018",
	"./index-login-full-screen.css": "e5a3",
	"./landing-page.css": "3313",
	"./main.css": "5aea",
	"./minor_css/proxy/bootstrap.min.css": "f341",
	"./minor_css/proxy/bootstrap.min.css.map": "b841",
	"./minor_css/proxy/proxy_style.css": "9269",
	"./my-mall.css": "9561",
	"./my_kyc.css": "8e8d",
	"./nav-login.css": "db7a",
	"./newLanding.css": "309b",
	"./popup.css": "c1b1",
	"./reset.css": "4ee2",
	"./style.css": "6672",
	"./useful_link.css": "cac3",
	"./vip.css": "b88a"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "118e";
module.exports = webpackAsyncContext;